<template>
    <div class="container">
        <div class="section-header text-center">
            <h2>Vendidos<span> de la semana</span></h2>
        </div>
        <div class="row">
            <div
                class="col-md-4 col-sm-12"
                v-for="(carro, index) in carros"
                :key="index"
            >
                <div class="featured-listing-wrap">
                    <div class="listing-image">
                        <a
                            :href="
                                `/ficha_tecnica/${carro.vehiculo.id_consignacion}`
                            "
                        >
                            <img
                                :src="
                                    'https://d16vbrqyk5474c.cloudfront.net/fit-in/450x300/' +
                                        carro.fotos.foto_principal
                                "
                                alt="image"
                            />
                        </a>
                    </div>
                    <h4 class="title-recents">
                        <a
                            :href="
                                `/ficha_tecnica/${carro.vehiculo.id_consignacion}`
                            "
                            >{{ carro.marca }}
                            {{ carro.linea }}
                            {{ carro.modelo }}</a
                        >
                    </h4>

                    <div class="price_info">
                        <p class="featured-price">
                            $
                            {{ formatNumber(carro.precio) }}
                        </p>
                        <div class="car-location">
                            <span>
                                <i
                                    class="fa fa-map-marker"
                                    aria-hidden="true"
                                ></i>
                                {{ carro.ubicacion }}
                            </span>
                        </div>
                    </div>
                    <div class="listing-meta">
                        <ul>
                            <li>
                                {{ get_combustible(carro.combustible) }}
                            </li>
                            <li>
                                {{ formatNumber(carro.kilometraje) }} km
                            </li>
                            <li>
                                {{ get_tipo_caja(carro.caja) }}
                            </li>
                            <li>{{ carro.clindraje }} cc</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainHelper from "helpers/main-helper";
export default {
    props: ["carros"],
    methods: {
        returnMainImage(data) {
            if (data.fichatecnica.tipo_plan == "gratis") {
                return data.fichatecnica.inspeccion_mecanica.fotos[0];
            } else {
                return data.fichatecnica.inspeccion.fotosvideo.fotos[0];
            }
        },
         formatNumber(number) {
            return mainHelper.numberWithoutDots(number);
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Triptonic";
                    break;
            }
        }
    }
};
</script>

<style lang="scss">
.listing-meta {
    border-bottom: 1px solid #e7e6e6;
}
.featured-listing-wrap ul {
    padding: 0;
    margin: 0 auto 5px !important;
}
.featured-listing-wrap h4 {
    margin: 0 auto 6px;
    font-size: 18px;
}
</style>
